const formatDate = date => {
	const unixTimeZero = Date.parse(date)
	let final = new Date(unixTimeZero)
	let day = final.getDate()
	let month = final.getMonth()
	let year = final.getFullYear()
	let hours = final.getHours()
	let minutes = final.getMinutes()
	let seconds = final.getSeconds()
	seconds = seconds.toString().padStart(2, "0")
	let ampm = hours >= 12 ? "PM" : "AM"
	hours = hours % 12
	hours = hours ? hours : 12 // the hour '0' should be '12'
	minutes = minutes < 10 ? "0" + minutes : minutes
	let strTime = hours + ":" + minutes + " " + ampm
	let strTimeWithSec = hours + ":" + minutes + ":" + seconds + " " + ampm
	const mL = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	]
	const mS = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"June",
		"July",
		"Aug",
		"Sept",
		"Oct",
		"Nov",
		"Dec",
	]
	const monthName = mS[month]
	return {
		day: day,
		month: monthName,
		year: year,
		time: strTime,
		date: `${day} ${monthName} ${year}`,
		dateTime: `${day} ${monthName} ${strTime}`,
		currentDate: `${day} ${monthName} ${year} ${strTimeWithSec}`,
		baseDate: `${day} ${monthName} ${year} 00:00:00 AM`,
	}
}

export default formatDate
